import { render, staticRenderFns } from "./Unsubscriber.vue?vue&type=template&id=229adafc&scoped=true"
import script from "./Unsubscriber.vue?vue&type=script&lang=js"
export * from "./Unsubscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229adafc",
  null
  
)

export default component.exports